(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/emp-video-player/assets/javascripts/helpers/setup-footer.js') >= 0) return;  svs.modules.push('/components/components/emp-video-player/assets/javascripts/helpers/setup-footer.js');
'use strict';

var registerFooterComponents = function registerFooterComponents() {
  var Button = empPlayer.videojs.getComponent('Button');
  var Component = empPlayer.videojs.getComponent('Component');
  var DurationInfo = empPlayer.videojs.extend(Component, {
    constructor: function constructor(player, options) {
      var _this = this;
      Component.apply(this, arguments);
      player.on('timeupdate', function () {
        var durationTime = empPlayer.videojs.formatTime(player.duration());
        var currentTime = empPlayer.videojs.formatTime(player.currentTime());
        var updated = "".concat(currentTime, " / ").concat(durationTime);
        _this.updateTextContent(updated);
      });

      if (options.text) {
        this.updateTextContent(options.text);
      }
    },
    createEl: function createEl() {
      return empPlayer.videojs.dom.createEl('div', {
        className: 'vjs-duration-info'
      });
    },
    updateTextContent: function updateTextContent(text) {
      if (typeof text !== 'string') {
        text = ' ';
      }
      empPlayer.videojs.dom.emptyEl(this.el());
      empPlayer.videojs.dom.appendContent(this.el(), text);
    }
  });
  var FooterButton = empPlayer.videojs.extend(Button, {
    constructor: function constructor(player, options) {
      Button.apply(this, arguments);
      var footerButton = options.footerButton;
      this.customOnClick = footerButton.customOnClick;
      this.addClass('icon');
      this.addClass(footerButton.icon);
      this.controlText(footerButton.controlText);
      if (footerButton.customClass) {
        this.addClass(footerButton.customClass);
      }
    },
    handleClick: function handleClick() {
      this.customOnClick();
    }
  });
  empPlayer.videojs.registerComponent('FooterButton', FooterButton);
  empPlayer.videojs.registerComponent('DurationInfo', DurationInfo);
};
var setupFooter = function setupFooter(options) {
  var player = options.player;

  player.getChild('controlBar').removeChild('DurationInfo');
  player.getChild('controlBar').removeChild('FooterButton');
  player.off('fullscreenchange');
  if (options.footerButton) {
    player.getChild('controlBar').addChild('FooterButton', {
      footerButton: options.footerButton
    }, 3);
    player.getChild('controlBar').getChild('FooterButton').toggleClass('vjs-hidden', document.fullscreenElement === player.el());
    player.on('fullscreenchange', function () {
      player.getChild('controlBar').getChild('FooterButton').toggleClass('vjs-hidden', document.fullscreenElement === player.el());
    });
  }
  if (options.showVideoDuration) {
    player.getChild('controlBar').addChild('DurationInfo');
  }
};
svs.components.emp_video_player.helpers.setupFooter = {
  setupFooter: setupFooter,
  registerFooterComponents: registerFooterComponents
};

 })(window);